export enum Hosts {
  data_center = "http://10.129.186.168",
  glob = "http://195.211.192.71",
  // doninturflot
  igor_stravinskiy = "http://10.128.80.7",
  tihiy_don = "http://10.127.16.10",
  anton_chehov = "http://10.128.96.10",
  ivan_bunin = "http://10.128.44.10",
  maksim_litvinov = "http://10.132.0.7",
  alexandra = "http://10.129.52.17",
  sergey_dyagilev = "http://10.127.248.2",
  volga_star = "http://10.128.24.2",
  general_lavrenenkov = "http://10.88.0.3",
  // Sputnik Germes
  anabella_princess = "http://10.128.208.6",
  // gazprom trans
  gpt_164_train = "http://10.200.4.60",
  gpt_156_train = "http://10.200.3.60",
  gpt_519_388_train = "http://10.200.2.60",
  gpt_370_520_train = "http://10.200.1.60",
  sibur = "http://10.131.116.60",
  // ТМХ KSK IT
  ТМХ_1 = "http://10.12.0.247",
  ТМХ_1_glob = "http://172.19.0.171",
}
enum TS {
  data_center = "http://10.129.186.168",
  glob = "http://195.211.192.71",
  igor_stravinskiy = "http://10.128.80.7",
  tihiy_don = "http://10.127.16.10",
  anton_chehov = "http://10.128.96.10",
  ivan_bunin = "http://10.128.44.10",
  maksim_litvinov = "http://10.132.0.7",
  alexandra = "http://10.129.52.17",
  sergey_dyagilev = "http://10.127.248.2",
  volga_star = "http://10.128.24.2",
  general_lavrenenkov = "http://10.88.0.3",
  anabella_princess = "http://10.128.208.6",
  gpt_164_train = "http://10.200.4.61",
  gpt_156_train = "http://10.200.3.60",
  gpt_519_388_train = "http://10.200.2.61",
  gpt_370_520_train = "http://10.200.1.61",
  sibur = "http://10.131.116.60",
  ТМХ_1 = "http://10.12.0.247",
  ТМХ_1_glob = "http://172.19.0.171",
}
enum GPS {
  data_center = "http://10.129.186.168",
  glob = "http://195.211.192.71",
  igor_stravinskiy = "http://10.128.80.7",
  tihiy_don = "http://10.127.16.10",
  anton_chehov = "http://10.128.96.10",
  ivan_bunin = "http://10.128.44.10",
  maksim_litvinov = "http://10.132.0.7",
  alexandra = "http://10.129.52.17",
  sergey_dyagilev = "http://10.127.248.2",
  volga_star = "http://10.128.24.2",
  general_lavrenenkov = "http://10.88.0.3",
  anabella_princess = "http://10.128.208.6",
  gpt_164_train = "http://10.200.4.60",
  gpt_156_train = "http://10.200.3.60",
  gpt_519_388_train = "http://10.200.2.60",
  gpt_520_370_train = "http://10.200.1.61",
  sibur = "http://10.131.116.60",
  ТМХ_1 = "http://10.12.0.247",
  ТМХ_1_glob = "http://172.19.0.171",
}
export const host = Hosts.data_center;
export const gps_host = GPS.data_center;
export const ts_host = TS.data_center;
